module.exports = __webpack_public_path__ + "src/assets/img/m30.dc577517.svg";